import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';

class DialogQuestionData {
	readonly question: string;
	readonly buttonColor: string;
	readonly titleButtonContinue: string;
	readonly titleButtonCancel: string | undefined;
	constructor(question: string, buttonColor: string, titleButtonContinue: string, titleButtonCancel?: string) {
		this.question = question;
		this.buttonColor = buttonColor;
		this.titleButtonContinue = titleButtonContinue;
		this.titleButtonCancel = titleButtonCancel;
	}
}

export const QUESTION_RESET_REQUESTED_DELIVERY_TIME = new DialogQuestionData(
	'eoffer.dialog.reset.requested.delivery.time',
	'warn',
	'eoffer.reset.requested.delivery.time',
	'eoffer.cancel'
);

interface DialogQuestionContent {
	data: DialogQuestionData;
	opContinue?(): void;
	opCancel?(): void;
}

@Component({
	selector: 'copo-offer-utils-dialog-question',
	templateUrl: './dialog-question.component.html',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, MatButtonModule, FocusMeDirective]
})
class DialogQuestionComponent {
	constructor(

		private readonly dialogRef: MatDialogRef<DialogQuestionComponent, boolean>,

		@Inject(MAT_DIALOG_DATA) readonly data: DialogQuestionData
	) {}

	evtContinue() {
		this.dialogRef.close(true);
	}

	evtCancel() {
		this.dialogRef.close(false);
	}
}

export class DialogQuestionUtils {
	constructor(private readonly dialog: MatDialog) {}
	open(content: DialogQuestionContent) {
		const sub = this.dialog
			.open<DialogQuestionComponent, DialogQuestionData, boolean>(
				DialogQuestionComponent,
				{
					data: content.data,
					panelClass: 'copo-offer-dialog'
				}
			)
			.afterClosed()
			.subscribe(resContinue => {
				sub.unsubscribe();
				// undefined when user clicks outside the dialog
				if (resContinue) {
					if (content.opContinue) {
						content.opContinue();
					}
				} else if (content.opCancel) {
					content.opCancel();
				}
			});
	}
}
